var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',[_c('img',{staticClass:"w-48",attrs:{"src":require("../../assets/images/transmaes_logo_big.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }